import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1efa6af1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = {
  role: "tablist",
  class: "nav nav-pills nav-fill px-4 mt-2"
}
const _hoisted_6 = ["id", "href", "aria-controls", "aria-selected", "onClick"]
const _hoisted_7 = { class: "d-sm-block pl-2 text-uppercase" }
const _hoisted_8 = {
  key: 0,
  class: "tab-pane active",
  role: "tabpanel"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "px-3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert d-flex text-primary",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lg fa-info-circle mt-2 mt-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pl-3 is-mobile" }, " Please set 'Advance Search' to view report results. "),
  /*#__PURE__*/_createElementVNode("div", { class: "pl-3 is-web" }, " Please set filter to view report results. ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-muted pt-3 mb-5" }, " No data ", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterComponent = _resolveComponent("FilterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FilterComponent, { onFilter: _ctx.getFilter }, null, 8, ["onFilter"]),
          _createVNode(_Transition, {
            name: "custom-classes-transition",
            "enter-active-class": "animate__animated animate__fadeIn animate__faster",
            "leave-active-class": "animate__animated animate__fadeOut animate__faster",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "nav-item mb-sm-3"
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link d-flex justify-content-center align-items-center shadow-none", { active: item.active }]),
                        id: item.id + '-tab',
                        "data-toggle": "tab",
                        href: '#' + item.id,
                        "aria-controls": item.id,
                        role: "tab",
                        "aria-selected": item.active,
                        onClick: ($event: any) => (_ctx.onTabChanged(index))
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)
                      ], 10, _hoisted_6)
                    ]))
                  }), 128))
                ]),
                (_ctx.hasData)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tabs.list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "tab-content"
                      }, [
                        _createVNode(_Transition, {
                          name: "fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (index === _ctx.activeTabIndex)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), { reportFilter: _ctx.reportFilter }, null, 8, ["reportFilter"]))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}